import React from 'react';
import ModalBackground from './components/ModalBackground/ModalBackground';
import Modal from './components/Modal/Modal';
import style from './style/modalwrapper.scss';

/**
 * Modal
 * - Provides a set of components that can optionally be used to construct a Modal
 * - renders provided children
 * - allows style overrides
 * @param {Object} props - props
 * @returns {*} Index
 * */
export default function Index(props) {
    const { children, classes = { modalWrapper: '' }, closeModal, useBackground = true } = props;

    return (
        <div className={ `${style.modalWrapper} ${classes.modalWrapper}` }>
            { useBackground
                ? <ModalBackground classes={ classes } closeModal={ closeModal } />
                : null
            }
            <Modal classes={ classes }>
                { children }
            </Modal>
        </div>
    );
}
